import {TelChoiceTabWrap, TelecomBtn} from 'src/styles/common/subscript'
import {certCheck, TelTypeState, } from 'src/store/recoil/common'
import {useRecoilState, useSetRecoilState} from 'recoil'
import {useEffect} from 'react'
import { MvnoCheckValue } from 'src/store/Join'

const TelChoiceTab = () => {
    const [TelType, setTelType] = useRecoilState(TelTypeState)
    const [CertCheck, setCertCheck] = useRecoilState(certCheck)
    const setMvnoCheckValue = useSetRecoilState(MvnoCheckValue)
    const TelTabOption = [
        {idx: 0, text: 'SKT', borderRadius: '10px 0 0 10px'},
        {idx: 1, text: 'KT', borderRadius: '0'},
        {idx: 2, text: 'LG U+', borderRadius: '0 10px 10px 0'}
    ]

    useEffect(() => {
        return () => {
            setTelType(0)
            setCertCheck(false)
            setMvnoCheckValue(false)
        }
    }, [setTelType, setCertCheck, setMvnoCheckValue])

    return (
        <TelChoiceTabWrap>
            {TelTabOption.map((option: { text: string, borderRadius: string, idx: number }) => (
                <TelecomBtn
                    disabled={CertCheck}
                    key={option.text} borderRadius={option.borderRadius} active={`${option.idx === TelType}`}
                    onClick={() => setTelType(option.idx)}
                >{option.text}
                </TelecomBtn>
            ))}
        </TelChoiceTabWrap>
    )
}
export default TelChoiceTab
